<template>
  <div class="TheFooterBottomContent footer-bottom-content">
    <p class="footer-bottom-content__text">
      Securities are offered through North Capital Private Securities Corporation (“NCPS”), a SEC registered Broker-Dealer
      and member of FINRA|SIPC. NCPS is not an affiliate of the AcreTrader Platform. Their form CRS can be viewed
      <a
        href="https://info.acretrader.com/e3t/Ctc/LW+113/cxSD-04/VVwwYK37wKzbW62Z_G27TVl_QW3Z50n15mr339N56dXhC3lYMRW7lCdLW6lZ3nsW6GXlzc98x5s1W6w4vh-5QFCfFW6BgZtf6s1ngBW7MttH67DVycWW90WkBx4GVCZWVK2PgD4kQMHRW4FKL4T1GftyCVmWGNN55FKfZW8z-Dls5zpyj0W4mHLgK3z1c6YVnf7R02_crfGW60hJSF2XCH8BW16d9Nl84t0fhMGmV4pWGdzDW1QMrCN60RV0XW3HQv-N3sJzw1W6Y6C_b2RCb1nW1c66nr8smnbyW6rFb8C80dS6vVbkzhd7qq6JCW5rVfMz6gYHYsW88lxVM6qFfBzN1pLDXDRmfP4W6Cwwg-1mWyS-dFjfbW04?utm_source=hs_email&utm_medium=email&_hsenc=p2ANqtz-85awCrPT5RgRv2Q_IDOS-atnPX8_oFeKYjEW5vWC3xHLTgKmD3zsqpYPBVHo7aCyT_eBGr"
        target="_blank"
        class="link-4 small-link footer-bottom-content__link"
      >here</a>
      and their BrokerCheck page can be viewed <a
        href="https://brokercheck.finra.org/firm/summary/154559"
        target="_blank"
        class="link-4 small-link footer-bottom-content__link"
      >here</a>.
    </p>
    <p class="footer-bottom-content__text">
      <strong>
        Past performance is no guarantee of future results. All investments are risky, and you should
        not invest unless you are able to sustain the risk of loss of your entire investment.
      </strong>
      For more information read our
      <router-link
        :to="{ name: 'terms', hash: '#general-disclosures' }"
        class="link-4 small-link footer-bottom-content__link"
      >
        <!-- eslint-disable-next-line -->
        General Disclosures</router-link>
      and
      <router-link
        :to="{ name: 'terms', hash: '#securities-matters' }"
        class="link-4 small-link footer-bottom-content__link"
      >
        <!-- eslint-disable-next-line -->
        Securities Matters</router-link>
      and for a more complete description of these investment risks click
      <a
        class="link-4 small-link"
        :href="require('doc/Acretrader-General-Risk-Statement.pdf')"
        target="_blank"
      >
        Acretrader General Risk Document</a>.
    </p>
    <p class="footer-bottom-content__text is--last">
      Content provided is not intended to be a recommendation or investment advice and is not an offer to
      buy or sell any specific security.  Information provided does not take into account an investor’s specific
      objectives or risk profile.  Investment decisions should be made based on your objectives and circumstances
      and in consultation with your own advisors. AcreTrader does not provide tax, legal or accounting advice.
      Please consult with and rely on a qualified professional.
    </p>
  </div>
</template>

<script lang="ts">
import { defineComponent } from 'vue';

export default defineComponent({
  name: 'TheFooterBottomContent',
});
</script>
<style lang="sass" scoped>
@import '~Styles/_variables'
.footer-bottom-content
  &__link
    font-size: 12px
    line-height: 16.8px
  &__text
    color: $alabaster
    +font(400)
    font-size: 12px
    line-height: 16.8px
    margin-bottom: 16px
    strong
      color: $alabaster !important
    &.is--last
      margin-bottom: 0
</style>
